/**
 * Componente para seleção de idioma
 * 
 * Permite ao usuário alternar entre os idiomas suportados
 * Versão melhorada com ícone e visual atraente
 */

import { useI18n } from '@/shared/hooks/useI18n';
import { Button } from '@/shared/ui/button';
import { Globe, Check } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shared/ui/dropdown-menu';

export function LanguageSelector() {
  const { currentLanguage, changeLanguage, supportedLanguages } = useI18n();

  const languageConfig: Record<string, { name: string; code: string; flag: string }> = {
    'pt-BR': {
      name: 'Português',
      code: 'PT',
      flag: '🇧🇷',
    },
    en: {
      name: 'English',
      code: 'EN',
      flag: '🇺🇸',
    },
    es: {
      name: 'Español',
      code: 'ES',
      flag: '🇪🇸',
    },
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-9 px-3 text-white/70 hover:text-white hover:bg-white/10 transition-colors flex items-center gap-2"
          title="Alterar idioma"
        >
          <Globe className="h-4 w-4" />
          <span className="text-xs font-medium hidden sm:inline">
            {languageConfig[currentLanguage]?.code || 'PT'}
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="w-48 bg-[#222222] border-white/10 shadow-lg"
      >
        <div className="p-1">
          {supportedLanguages.map((lang) => {
            const config = languageConfig[lang];
            const isActive = currentLanguage === lang;
            
            return (
              <DropdownMenuItem
                key={lang}
                onClick={() => changeLanguage(lang)}
                className={`cursor-pointer transition-all rounded-md ${
                  isActive
                    ? 'bg-[#C1174F] text-white font-medium'
                    : 'text-white/80 hover:bg-white/10 hover:text-white'
                }`}
              >
                <div className="flex items-center gap-3 w-full">
                  <span className="text-lg">{config.flag}</span>
                  <div className="flex-1 flex items-center justify-between">
                    <div className="flex flex-col">
                      <span className="text-sm font-medium">{config.name}</span>
                      <span className="text-xs opacity-70">{config.code}</span>
                    </div>
                    {isActive && (
                      <Check className="h-4 w-4 ml-2" />
                    )}
                  </div>
                </div>
              </DropdownMenuItem>
            );
          })}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}


